import Spinner from '@cloudscape-design/components/spinner';
import Box from '@cloudscape-design/components/box';

interface LoadingSpinnerProps {
  size?: 'normal' | 'big' | 'large';
  label?: string;
}

export default function LoadingSpinner({ size = 'normal', label = 'Loading...' }: LoadingSpinnerProps) {
  return (
    <Box textAlign="center" padding="xl">
      <Spinner size={size} />
      {label && (
        <Box variant="p" color="text-body-secondary" padding={{ top: 's' }}>
          {label}
        </Box>
      )}
    </Box>
  );
}
